class ProductModal extends ModalDialog {
  constructor() {
    super();
  }

  hide() {
    super.hide();
    window.pauseAllMedia();
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();
  }

  showActiveMedia() {
    this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
      element.classList.remove('active');
    });
    const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
    const activeMediaTemplate = activeMedia.querySelector('template');
    const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
    activeMedia.classList.add('active');
    activeMedia.scrollIntoView();

    const container = this.querySelector('[role="document"]');
    container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

    if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
      activeMedia.loadContent();
  }
}

customElements.define('product-modal', ProductModal);

var scrollToElement = function (element) {
  if (!element) return;
  var $innerListItem = $(element),
    $parentDiv = $(element).parent();
  $parentDiv.scrollTop($parentDiv.scrollTop() + $innerListItem.position().top - $parentDiv.height() + $innerListItem.height());
};

var setNavHeight = function () {
  setTimeout(function () {
    $('.carousel-nav-list').height(
      $('.productwithtext-carousel').find('.slick-slide[data-slick-index=0] img').height() -
      $('.carousel-btn').height() * 2
    );
  }, 250);
};

$('.freq-option').click(function () {
  $('.freq-option').removeClass('selecteds');
  var radios = $('input.favour_input:checked').val();

  $(this).each(function () {
    if ($(this).hasClass('subscripts')) {
      $("div#qtyOptions").css("display", "none");
      $('#qtyOptions li.bag1').click();
      $(".total-price").text("$" + totalprice1.toFixed(2));
      $(".regular-price").text("$" + subprice.toFixed(2));
      $(".saving-text").text(saveText);
      $(".atc-btn--total_price").text("($" + subprice.toFixed(2) + ")");
      $(".subs-purchase").text(customSubscText);
      console.log(savingprice1);
      $(".regular-price-one-time.atc-btn-price").text("$" + regularprice1.toFixed(2) + ' | ' + buytext + ' $' + savingprice1.toFixed(2));
    } else {
      $('#qtyOptions').css('display', 'block');

      if (radios == '1') {
        $(".total-price").text("$" + totalprice1.toFixed(2));
        $(".regular-price").text("$" + regularprice1.toFixed(2));
        $(".saving-text").text(saveText1);
        $(".atc-btn--total_price").text("($" + regularprice1.toFixed(2) + ")");
        $(".regular-price-one-time.atc-btn-price").text("$" + regularprice1.toFixed(2) + ' | ' + buytext + ' $' + savingprice1.toFixed(2));
      } else if (radios == '2') {
        $(".total-price").text("$" + totalprice2.toFixed(2));
        $(".regular-price").text("$" + regularprice2.toFixed(2));
        $(".saving-text").text(saveText2);
        $(".atc-btn--total_price").text("($" + regularprice2.toFixed(2) + ")");
        $(".regular-price-one-time.atc-btn-price").text("$" + regularprice2.toFixed(2) + ' | ' + buytext + ' $' + savingprice2.toFixed(2));
      } else {
        $(".total-price").text("$" + totalprice4.toFixed(2));
        $(".regular-price").text("$" + regularprice4.toFixed(2));
        $(".saving-text").text(saveText4);
        $(".atc-btn--total_price").text("($" + regularprice4.toFixed(2) + ")");
        $(".regular-price-one-time.atc-btn-price").text("$" + regularprice4.toFixed(2) + ' | ' + buytext + ' $' + savingprice4.toFixed(2));
      }
    }
    $(this).addClass("selecteds");
  });
});

$(document).ready(function () {
  $('#qtyOptions li').click(function () {
    $('#qtyOptions li').removeClass('selected');
    $('#qtyOptions li input').removeAttr('checked');

    $(this).each(function () {
      $(this).addClass("selected");
      $(this).find('input.favour_input').prop('checked', true);
      var radios2 = $(this).find('input.favour_input:checked').val();
      var radios_purchase = $('input.purchase-type:checked').val();

      if (radios2 == '1') {
        if (radios_purchase === 'onetime') {
          $(".total-price").text("$" + totalprice1.toFixed(2));
          $(".regular-price").text("$" + regularprice1.toFixed(2));
          $(".saving-text").text(saveText1);
          $(".atc-btn--total_price").text("($" + regularprice1.toFixed(2) + ")");
          $(".regular-price-one-time.atc-btn-price").text("$" + regularprice1.toFixed(2) + ' | ' + buytext + ' $' + savingprice1.toFixed(2));
        } else {
          $(".total-price").text("$" + totalprice1.toFixed(2));
          $(".regular-price").text("$" + subprice.toFixed(2));
          $(".saving-text").text(saveText);
          $(".atc-btn--total_price").text("($" + subprice.toFixed(2) + ")");
          $(".regular-price-one-time.atc-btn-price").text(`$`);
        }
      } else if (radios2 == '2') {
        $(".total-price").text("$" + totalprice2.toFixed(2));
        $(".regular-price").text("$" + regularprice2.toFixed(2));
        $(".saving-text").text(saveText2);
        $(".atc-btn--total_price").text("($" + regularprice2.toFixed(2) + ")");
        $(".regular-price-one-time.atc-btn-price").text("$" + regularprice2.toFixed(2) + ' | ' + buytext + ' $' + savingprice2.toFixed(2));
      } else {
        $(".total-price").text("$" + totalprice4.toFixed(2));
        $(".regular-price").text("$" + regularprice4.toFixed(2));
        $(".saving-text").text(saveText4);
        $(".atc-btn--total_price").text("($" + regularprice4.toFixed(2) + ")");
        $(".regular-price-one-time.atc-btn-price").text("$" + regularprice4.toFixed(2) + ' | ' + buytext + ' $' + savingprice4.toFixed(2));
      }
    });
  });
});

const product_obj_arr = [
  { qty: 1, regular_price: 49.42, price: 42.99, saving: '25%', label: '1-Bag' },
  { qty: 2, regular_price: 98.84, price: 73.08, saving: '26.06%', price_each: '$36.54 EACH', label: '2-Bags' },
  { qty: 4, regular_price: 431.60, price: 199.80, saving: '30.41%', price_each: '$49.95 EACH', label: '4-Bags' }
];

// const free_products = [
//   44086642311354 // Pre workout
// ];

const qty_radios = document.querySelectorAll('input[name="quantity"]');
const purchase_type = document.querySelectorAll('input[name="purchase_type"]');
const qty_options = document.getElementById('qtyOptions');
const atc_btn = document.getElementById('addToCartBtn');

function getQtyData(qty) {
  return product_obj_arr.find((obj) => obj.qty === qty);
}

function purchaseType() {
  purchase_type.forEach(btn => {
    btn.addEventListener('change', function (event) {
      if (event.target.type === 'radio' && event.target.checked) {
        qty_options.style.display = event.target.value === 'onetime' ? 'block' : 'none';
      }
    });
  });
}

function getDiscountCode() {
  const qty = document.querySelector('input[name="quantity"]:checked').value;
  const type = document.querySelector('input[name="purchase_type"]:checked').value;

  if (qty === '1' && type === 'onetime') return 'CREATINE1ONETIME';
  if (qty === '2' && type === 'onetime') return 'CREATINE2ONETIME';
  if (qty === '4' && type === 'onetime') return 'CREATINE4ONETIME';
  if (qty === '1' && type === 'subscription') return 'CREATINE1SUBSCRIPTION';
  return null;
}

function checkout_redirect() {
  const variantId = parseInt(atc_btn.dataset.variantId, 10);
  const sellingPlanId = parseInt(atc_btn.dataset.sellingPlanId, 10);

  atc_btn.addEventListener('click', function () {
    const selected_purchase_type = document.querySelector('input[name="purchase_type"]:checked').value;
    const selected_qty = document.querySelector('input[name="quantity"]:checked').value;
    const discount_code = getDiscountCode();
    let cart_items = [];

    if (selected_purchase_type === 'onetime') {
      cart_items.push({
        id: variantId,
        quantity: parseInt(selected_qty, 10),
        properties: {
          "expected_delivery": atc_btn.dataset.expectedDelivery
        }
      });
    } else {
      cart_items.push({
        id: variantId,
        quantity: 1,
        selling_plan: sellingPlanId,
        properties: {
          "_compare_at_price": '8040',
          "is_prepaid": false,
          "expected_delivery": atc_btn.dataset.expectedDelivery
        }
      });
    }

    // free_products.forEach(free_product => {
    //   cart_items.push({
    //     id: free_product,
    //     quantity: 1,
    //     properties: { "paid_offer_free": 'free_products' }
    //   });
    // });

    fetch('/cart/clear.js', { method: 'POST' })
      .then(response => {
        if (!response.ok) throw new Error('Error clearing the cart');

        const cartSection = document.querySelector('.cart-section');
        if (cartSection && cartSection.parentNode) {
          cartSection.parentNode.style.display = 'none';
        }

        CartJS.addItems(cart_items, {
          "success": function () {
            window.location.href = discount_code
              ? `/checkout?discount=${discount_code}`
              : '/checkout';
          },
          "error": function () {
            const cartSection = document.querySelector('.cart-section');
            if (cartSection && cartSection.parentNode) {
              cartSection.parentNode.style.display = 'block';
            }
          }
        });
      });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  purchaseType();
  checkout_redirect();
});